import React from 'react';
import CheckboxGroup from './CheckboxGroup';
import {
  useCreateClientProspectScoreSettingCustomizeItemSelectOptionMutation,
  useDestroyClientProspectScoreSettingCustomizeItemSelectOptionMutation,
  PoolCustomizeItemSelectOption,
} from 'api';
import {CustomizeItemContext} from '../../../CustomizeItemContext';

interface Props {
  priority: number;
}

export default ({priority}: Props) => {
  const [create] =
    useCreateClientProspectScoreSettingCustomizeItemSelectOptionMutation({});
  const [destroy] =
    useDestroyClientProspectScoreSettingCustomizeItemSelectOptionMutation({});
  const {
    id,
    poolProspectCustomizeItem,
    selectOptionsGroupByPriority,
    clientProspectScoreSettingCustomizeItemSelectOptions,
  } = React.useContext(CustomizeItemContext);

  const options = [
    ...poolProspectCustomizeItem?.selectOptions?.map(
      (option: PoolCustomizeItemSelectOption) => ({
        text: option.label,
        value: option.id,
        keyword: option.label,
      }),
    ),
  ];

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const {checked, value} = e.target;
    const variables = {
      priority,
      prospectScoreSettingCustomizeItemId: id,
      poolProspectCustomizeItemSelectOptionId: value,
    };
    if (checked) {
      create({
        variables,
      });
    } else {
      destroy({
        variables,
      });
    }
  };

  return (
    <CheckboxGroup
      filter
      options={options}
      values={
        selectOptionsGroupByPriority?.[priority]?.map(
          (option: PoolCustomizeItemSelectOption) => String(option.id),
        ) ?? []
      }
      allSelected={clientProspectScoreSettingCustomizeItemSelectOptions.map(
        (option) => option.poolProspectCustomizeItemSelectOptionId,
      )}
      onChange={handleChange}
    />
  );
};
